<template>
  <div class="services-page">
    <div class="service-header">
      <h1>Our Services</h1>
      <p>Comprehensive care for you and your furry friends</p>
    </div>

    <div class="service-details">
      <section id="behavioral" class="service-section">
        <h2>Behavioral Management</h2>
        <div class="service-content">
          <div class="service-image">
            <img src="https://via.placeholder.com/400x300?text=Behavioral+Management" alt="Behavioral Management">
          </div>
          <div class="service-text">
            <h3>Mental Wellness & Behavioral Health</h3>
            <p>Our behavioral management program offers:</p>
            <ul>
              <li>Personalized mental wellness strategies</li>
              <li>Stress reduction techniques</li>
              <li>Behavioral modification support</li>
              <li>Pet-assisted therapy sessions</li>
            </ul>
            <button class="book-button">Schedule Consultation</button>
          </div>
        </div>
      </section>

      <section id="social" class="service-section">
        <h2>Friendship and Socialization</h2>
        <div class="service-content">
          <div class="service-text">
            <h3>Building Meaningful Connections</h3>
            <p>Our socialization programs include:</p>
            <ul>
              <li>Group pet playdate sessions</li>
              <li>Community meetups</li>
              <li>Social skills development</li>
              <li>Pet owner support groups</li>
            </ul>
            <button class="book-button">Join Community</button>
          </div>
          <div class="service-image">
            <img src="https://via.placeholder.com/400x300?text=Socialization" alt="Socialization">
          </div>
        </div>
      </section>

      <section id="pet" class="service-section">
        <h2>Pet Care Services</h2>
        <div class="service-content">
          <div class="service-image">
            <img src="https://via.placeholder.com/400x300?text=Pet+Care" alt="Pet Care">
          </div>
          <div class="service-text">
            <h3>Comprehensive Pet Care</h3>
            <p>We provide:</p>
            <ul>
              <li>Regular health check-ups</li>
              <li>Grooming services</li>
              <li>Nutrition consultation</li>
              <li>Exercise programs</li>
            </ul>
            <button class="book-button">Book Pet Care</button>
          </div>
        </div>
      </section>

      <section id="physical" class="service-section">
        <h2>Physical Wellness</h2>
        <div class="service-content">
          <div class="service-text">
            <h3>Holistic Health Approaches</h3>
            <p>Our wellness programs feature:</p>
            <ul>
              <li>Pet-friendly exercise classes</li>
              <li>Wellness workshops</li>
              <li>Nutrition guidance</li>
              <li>Health monitoring</li>
            </ul>
            <button class="book-button">Start Wellness Journey</button>
          </div>
          <div class="service-image">
            <img src="https://via.placeholder.com/400x300?text=Physical+Wellness" alt="Physical Wellness">
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ServicesView'
}
</script>

<style scoped>
.services-page {
  padding: 2rem 5%;
}

.service-header {
  text-align: center;
  margin-bottom: 4rem;
}

.service-header h1 {
  font-size: 2.5rem;
  color: #2c3e50;
  margin-bottom: 1rem;
}

.service-section {
  margin-bottom: 6rem;
  scroll-margin-top: 100px;
}

.service-section h2 {
  color: #2c3e50;
  margin-bottom: 2rem;
  font-size: 2rem;
}

.service-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;
  align-items: center;
}

.service-image img {
  width: 100%;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
}

.service-text {
  padding: 2rem;
}

.service-text h3 {
  color: #42b983;
  margin-bottom: 1rem;
}

.service-text ul {
  list-style-type: none;
  padding: 0;
  margin: 1rem 0;
}

.service-text li {
  margin: 0.5rem 0;
  padding-left: 1.5rem;
  position: relative;
}

.service-text li::before {
  content: "•";
  color: #42b983;
  position: absolute;
  left: 0;
}

.book-button {
  margin-top: 1.5rem;
  padding: 0.8rem 1.5rem;
  background: #42b983;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background 0.3s ease;
}

.book-button:hover {
  background: #3aa876;
}

@media (max-width: 768px) {
  .service-content {
    grid-template-columns: 1fr;
  }
  
  .service-section:nth-child(even) .service-content {
    flex-direction: column-reverse;
  }
}
</style> 